import axios from "axios"
import { addYears, addMonths } from "date-fns";
import { reservationsPutAxios } from "./reservationsPutAxios";


const startYears = addYears(new Date(), -1);
const endMonth = addMonths(new Date(), 1);

export function reservationsReturnAxios(resData) {
        return async function reservationsReturnThunk(dispatch, getState) {
            await axios.post(`/api/returns/${resData?.reservationId}`, resData)
            dispatch(reservationsPutAxios({ startdate: startYears, enddate: endMonth,}))
        }
    }